/**
 * Device detection utilities for responsive behavior
 * Handles touch device detection and mobile-specific features
 */

export const useDeviceDetection = () => {
  const isTouchDevice = computed(() => {
    if (process.client) {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0
    }
    return false
  })
  
  const isMobile = computed(() => {
    if (process.client) {
      return window.innerWidth < 768
    }
    return false
  })

  const isTablet = computed(() => {
    if (process.client) {
      return window.innerWidth >= 768 && window.innerWidth < 1024 && isTouchDevice.value
    }
    return false
  })
  
  const isDesktop = computed(() => {
    if (process.client) {
      return window.innerWidth >= 1024 && !isTouchDevice.value
    }
    return false
  })

  // Touch-friendly sizes
  const touchTargetSize = computed(() => {
    if (isMobile.value) return 44 // iOS/Android accessibility guidelines
    if (isTablet.value) return 36
    return 20 // Desktop fallback
  })

  return { 
    isTouchDevice, 
    isMobile, 
    isTablet, 
    isDesktop,
    touchTargetSize
  }
}